import { getOrCreateDataLayer } from './dataLayer';
import { debounce } from './debounce';
import { IN_VIEW_ATTRIBUTE } from './inViewEventAttributes';
import { isInView } from './isInView';
import { trackComponentView } from './gabito/events/trackComponentView';
import { trackLinkClick } from './gabito/events/trackLinkClick';
import { trackResourceView } from './gabito/events/trackResourceView';
import { setupFlavourPageTracking } from './gtm/setupFlavourPageTracking';
export const attachAnalyticsListeners = ({ analyticsRoot, isAuthenticated, pageName, countryCode, eventParams, }) => {
    const dataLayer = getOrCreateDataLayer();
    function allAttributesPopulated(object) {
        const values = Object.keys(object).map(e => object[e]);
        return !values.some(x => x === null);
    }
    function populateAttribute(currentElement, returnObject, attribute, htmlAttribute) {
        const attributeValue = currentElement.getAttribute(htmlAttribute);
        if (attributeValue && !returnObject[attribute]) {
            returnObject[attribute] = attributeValue;
        }
    }
    function buildPromotionObject(element, clickEvent) {
        let currentElement = element;
        const returnObject = {
            countryCode: countryCode,
            variant: null,
            name: null,
            position: null,
            list: null,
        };
        if (clickEvent) {
            returnObject.href = null;
        }
        do {
            populateAttribute(currentElement, returnObject, 'variant', 'data-event-campaign-id');
            populateAttribute(currentElement, returnObject, 'name', 'data-event-offer-type-id');
            populateAttribute(currentElement, returnObject, 'list', 'data-component-name');
            populateAttribute(currentElement, returnObject, 'position', 'data-component-position');
            if (clickEvent && currentElement.hasAttribute('href')) {
                returnObject.href = currentElement.getAttribute('href');
            }
            if (allAttributesPopulated(returnObject) ||
                currentElement === analyticsRoot) {
                break;
            }
            if (currentElement.parentElement) {
                currentElement = currentElement.parentElement;
            }
        } while (currentElement.parentElement);
        return returnObject;
    }
    function parseEvent(element, clickEvent) {
        if (!element)
            return null;
        try {
            return buildPromotionObject(element, clickEvent);
        }
        catch (e) {
            return null;
        }
    }
    function pushPromoView(event) {
        dataLayer.push({
            event: 'eec.promotionView',
            ecommerce: {
                promoView: {
                    promotions: [event],
                },
            },
        });
    }
    function pushProductView(event) {
        dataLayer.push({
            event: 'eec.productView',
            ecommerce: {
                productView: {
                    promotions: [event],
                },
            },
        });
    }
    const seenViewElements = [];
    function pushStorefrontLoad(element) {
        dataLayer.push({
            event: 'plan-sensitive-storefront-load',
            error: element.getAttribute('data-storefront-error') ? true : false,
            'current-plan': element.getAttribute('data-current-plan'),
        });
    }
    function handleViewEvent(element) {
        if (seenViewElements.indexOf(element) === -1 && isInView(element)) {
            seenViewElements.push(element);
            const parsedEvent = parseEvent(element, false);
            trackComponentView({
                isAuthenticated,
                pageName,
                eventObject: parsedEvent,
            });
            if (element.getAttribute('data-component-name') === 'storefront') {
                pushStorefrontLoad(element);
            }
            if (element.getAttribute('data-component-type') === 'product') {
                pushProductView(parsedEvent);
            }
            else {
                pushPromoView(parsedEvent);
            }
        }
    }
    function trackInViewElements() {
        analyticsRoot
            .querySelectorAll(`[${IN_VIEW_ATTRIBUTE}]`)
            .forEach(element => {
            handleViewEvent(element);
        });
    }
    function pushPromoClick(event) {
        dataLayer.push({
            event: 'eec.promotionClick',
            ecommerce: {
                promoClick: {
                    promotions: [event],
                },
            },
        });
    }
    function pushProductClick(event) {
        dataLayer.push({
            event: 'eec.productClick',
            ecommerce: {
                productClick: {
                    promotions: [event],
                },
            },
        });
    }
    function handleClickEvent(element) {
        const parsedEvent = parseEvent(element, true);
        trackLinkClick({
            isAuthenticated,
            pageName,
            eventObject: parsedEvent,
        });
        if (element.getAttribute('data-component-type') === 'product') {
            pushProductClick(parsedEvent);
        }
        else {
            pushPromoClick(parsedEvent);
        }
    }
    function setupPromotionTracking() {
        if (!analyticsRoot) {
            return;
        }
        trackInViewElements();
        window.addEventListener('resize', debounce(trackInViewElements, 500));
        window.addEventListener('scroll', debounce(trackInViewElements, 500));
        window.addEventListener('orientationchange', debounce(trackInViewElements, 500));
        analyticsRoot.addEventListener('click', e => {
            if (e.target instanceof HTMLElement) {
                handleClickEvent(e.target);
            }
        }, { capture: true });
        setupFlavourPageTracking(analyticsRoot);
    }
    trackResourceView({
        isAuthenticated,
        resourceName: pageName,
        countryCode,
        offerTypeId: eventParams.offerTypeId || '',
        campaignId: eventParams.campaignId || '',
    });
    setupPromotionTracking();
};
//# sourceMappingURL=attachAnalyticsListeners.js.map